import type { GridElement } from '@omnia/ui/src/lib/cms/grid/interfaces/gridElement'
import { TabItem, Tabs, TabsDisplayType } from '@vista-digital/occ-ui'
import { type FC, useEffect, useMemo, useState } from 'react'
import { Grid } from '../Grid'
import type { CineColombiaGridRow } from '../grid.types'

interface GridTab {
    name: string
    grid: CineColombiaGridRow[] | undefined
}

export const TabLayout: FC<CineColombiaGridRow> = props => {
    const gridTabElements = useMemo(
        () => props.columns[0].elements.filter(e => e.type === 'gridTab') as Array<GridElement<GridTab>>,
        [props.columns]
    )

    const tabKeys = useMemo(() => gridTabElements.map(e => e.value.name), [gridTabElements])
    const [selectedTab, setSelectedTab] = useState<string>(tabKeys[0] ?? '')

    useEffect(() => {
        if (!selectedTab || !tabKeys.includes(selectedTab)) {
            setSelectedTab(tabKeys[0] ?? '')
        }
    }, [selectedTab, tabKeys])

    const selectedGrid = useMemo(() => {
        return gridTabElements.find(e => e.value.name === selectedTab)?.value.grid
    }, [gridTabElements, selectedTab])

    return (
        <>
            <div className="container-lg-padding grid-tabs" data-testid="tab-layout-tabs">
                <Tabs
                    centered
                    displayType={TabsDisplayType.Primary}
                    selectedTab={selectedTab}
                    onTabSelected={key => setSelectedTab(String(key))}
                >
                    {gridTabElements.map(element => (
                        <TabItem key={element.value.name}>{element.value.name}</TabItem>
                    ))}
                </Tabs>
            </div>
            <Grid rows={selectedGrid} />
        </>
    )
}
